import { useEffect } from "react"
import { useTranslation } from "react-i18next"

const TitleChanger = () => {
    const {i18n} = useTranslation()
    useEffect(() => {
        const titleComponent = document.querySelector("title")
        if(titleComponent) {
            titleComponent.innerHTML = 
                i18n.language == "tr" 
                ? "Ponyexpress kişisel hesabı"
                : "Личный кабинет ponyexpress"
        }
    }, [i18n.language])
}

export default TitleChanger